<template>
  <div v-if="evaluateQuote">
    <h1>Evaluate quote</h1>
    <router-link :to="{ name: 'quote', params: { id: $route.params.id } }">{{
      $route.params.id
    }}</router-link>
    <ul>
      <li
        v-for="(evaluateCategory, ecindex) in evaluateQuote.evaluateCategories"
        :key="ecindex"
      >
        <router-link
          v-if="$keycloak.hasRealmRole('root')"
          :to="{
            name: 'quoteCategory',
            params: { id: evaluateCategory.category.id }
          }"
          >{{ evaluateCategory.category.name }}</router-link
        >
        <span v-if="!$keycloak.hasRealmRole('root')">{{
          evaluateCategory.category.id
        }}</span>
        <ul>
          <li
            v-for="(evaluateSection, esindex) in evaluateCategory
              .evaluateQuoteScript.evaluateSections"
            :key="esindex"
          >
            <router-link
              v-if="$keycloak.hasRealmRole('root')"
              :to="{
                name: 'quoteSection',
                params: {
                  id: evaluateCategory.category.id,
                  quotescriptid:
                    evaluateCategory.evaluateQuoteScript.quotescriptid,
                  sectionid: evaluateSection.section.id
                }
              }"
              >{{ evaluateSection.section.xmlTag }}</router-link
            >
            <span v-if="!$keycloak.hasRealmRole('root')">{{
              evaluateSection.section.xmlTag
            }}</span>
            <ul>
              <li
                v-for="(
                  evaluateRuleSet, erindex
                ) in evaluateSection.evaluateRuleSets"
                :key="erindex"
              >
                <router-link
                  v-if="$keycloak.hasRealmRole('root')"
                  :to="{
                    name: 'quoteRuleSet',
                    params: {
                      id: evaluateRuleSet.ruleSet.id
                    }
                  }"
                  >{{ evaluateRuleSet.ruleSet.heading }}</router-link
                >
                <ul>
                  <li
                    v-for="(
                      evaluateRule, erindex
                    ) in evaluateRuleSet.evaluateRules"
                    :key="erindex"
                  >
                    <div :class="evaluateRule.styleClass">
                      <div>
                        <router-link
                          v-if="$keycloak.hasRealmRole('root')"
                          :to="{
                            name: 'quoteRule',
                            params: {
                              id: evaluateCategory.category.id,
                              quotescriptid:
                                evaluateCategory.evaluateQuoteScript
                                  .quotescriptid,
                              sectionid: evaluateSection.section.id,
                              ruleid: evaluateRule.ruleid
                            }
                          }"
                          >Rule</router-link
                        >
                        <span v-if="!$keycloak.hasRealmRole('root')">Rule</span>
                        <v-chip
                          color="red"
                          text-color="white"
                          small
                          v-if="evaluateRule.broken"
                          >Not used</v-chip
                        >
                        <v-chip
                          color="green"
                          text-color="white"
                          small
                          v-if="!evaluateRule.broken"
                          >Used</v-chip
                        >
                      </div>
                      <ul>
                        <li
                          v-for="(
                            evaluateCondition, ecindex
                          ) in evaluateRule.evaluateConditions"
                          :key="ecindex"
                        >
                          <router-link
                            v-if="$keycloak.hasRealmRole('root')"
                            :to="{
                              name: 'quoteCondition',
                              params: {
                                id: evaluateCategory.category.id,
                                quotescriptid:
                                  evaluateCategory.evaluateQuoteScript
                                    .quotescriptid,
                                sectionid: evaluateSection.section.id,
                                ruleid: evaluateRule.ruleid,
                                conditionid: evaluateCondition.conditionid
                              }
                            }"
                            >Condition</router-link
                          >
                          <span v-if="!$keycloak.hasRealmRole('root')"
                            >Condition</span
                          >
                          <EvaluateLogs :logs="evaluateCondition.logs" />
                        </li>
                      </ul>
                      <ul>
                        <li
                          v-for="(
                            evaluateAction, eaindex
                          ) in evaluateRule.evaluateActions"
                          :key="eaindex"
                        >
                          <router-link
                            v-if="$keycloak.hasRealmRole('root')"
                            :to="{
                              name: 'quoteAction',
                              params: {
                                id: evaluateCategory.category.id,
                                quotescriptid:
                                  evaluateCategory.evaluateQuoteScript
                                    .quotescriptid,
                                sectionid: evaluateSection.section.id,
                                ruleid: evaluateRule.ruleid,
                                actionid: evaluateAction.actionid
                              }
                            }"
                            >Action</router-link
                          >
                          <span v-if="!$keycloak.hasRealmRole('root')"
                            >Action</span
                          >
                          <EvaluateLogs :logs="evaluateAction.logs">
                            <li>
                              <span>Secondary</span>
                              <EvaluateLogs
                                v-if="evaluateAction.evaluateSecondaryPrevious"
                                :logs="
                                  evaluateAction.evaluateSecondaryPrevious.logs
                                "
                              />
                              <EvaluateLogs
                                v-if="evaluateAction.evaluateSecondaryQuestion"
                                :logs="
                                  evaluateAction.evaluateSecondaryQuestion.logs
                                "
                              />
                              <EvaluateLogs
                                v-if="
                                  evaluateAction.evaluateSecondaryPercentage
                                "
                                :logs="
                                  evaluateAction.evaluateSecondaryPercentage
                                    .logs
                                "
                              />
                              <EvaluateLogs
                                v-if="
                                  evaluateAction.evaluateSecondaryParameterPercentage
                                "
                                :logs="
                                  evaluateAction
                                    .evaluateSecondaryParameterPercentage.logs
                                "
                              />
                            </li>
                            <li>
                              <span>Value</span>
                              <EvaluateCalcFixed
                                v-if="evaluateAction.evaluateCalcFixed"
                                :calcFixed="evaluateAction.evaluateCalcFixed"
                                :parameterTypesMap="parameterTypesMap"
                              />
                              <EvaluateCalcScaleFee
                                v-if="evaluateAction.evaluateCalcScaleFee"
                                :calcScaleFee="
                                  evaluateAction.evaluateCalcScaleFee
                                "
                                :scaleFeeTypesMap="scaleFeeTypesMap"
                              />
                              <EvaluateCalcScalePercentage
                                v-if="
                                  evaluateAction.evaluateCalcScalePercentage
                                "
                                :calcScalePercentage="
                                  evaluateAction.evaluateCalcScalePercentage
                                "
                                :scalePercentageTypesMap="
                                  scalePercentageTypesMap
                                "
                              />
                              <EvaluateCalcFeePercentage
                                v-if="evaluateAction.evaluateCalcFeePercentage"
                                :calcFeePercentage="
                                  evaluateAction.evaluateCalcFeePercentage
                                "
                                :parameterTypesMap="parameterTypesMap"
                              />
                              <EvaluateLogs
                                v-if="evaluateAction.evaluateCalcUser"
                                :logs="evaluateAction.evaluateCalcUser.logs"
                              />
                              <EvaluateLogs
                                v-if="evaluateAction.evaluateCalcMultiply"
                                :logs="evaluateAction.evaluateCalcMultiply.logs"
                              />
                            </li>
                          </EvaluateLogs>
                          <h3>
                            <span v-if="evaluateAction.quoteItem.description"
                              >{{
                                evaluateAction.quoteItem.description.body
                              }}&#160;</span
                            >
                            <span
                              v-if="evaluateAction.quoteItem.secondary"
                              style="color: gray"
                              >{{
                                evaluateAction.quoteItem.secondary.body
                              }}&#160;</span
                            >
                            <span>{{
                              evaluateAction.quoteItem.value | toCurrency
                            }}</span>
                          </h3>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import EvaluateCalcFeePercentage from "@/components/quote/evaluate/CalcFeePercentage";
import EvaluateCalcFixed from "@/components/quote/evaluate/CalcFixed";
import EvaluateCalcScaleFee from "@/components/quote/evaluate/CalcScaleFee";
import EvaluateCalcScalePercentage from "@/components/quote/evaluate/CalcScalePercentage";
import EvaluateLogs from "@/components/quote/evaluate/Logs";
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EvaluateQuote",
  metaInfo() {
    return {
      title: "Evaluate quote",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EvaluateCalcFeePercentage,
    EvaluateCalcFixed,
    EvaluateCalcScaleFee,
    EvaluateCalcScalePercentage,
    EvaluateLogs
  },
  computed: {
    parameterTypesMap() {
      return this.parameterTypes
        ? convertListOfObjectsToMap(this.parameterTypes, "id")
        : undefined;
    },
    scaleFeeTypesMap() {
      return this.scaleFeeTypes
        ? convertListOfObjectsToMap(this.scaleFeeTypes, "id")
        : undefined;
    },
    scalePercentageTypesMap() {
      return this.scalePercentageTypes
        ? convertListOfObjectsToMap(this.scalePercentageTypes, "id")
        : undefined;
    }
  },
  data() {
    return {
      evaluateQuote: null,
      descriptions: null,
      secondaries: null,
      parameterTypes: null,
      scaleFeeTypes: null,
      scalePercentageTypes: null
    };
  },
  methods: {
    async fetchEvaluateQuote() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quotes/${this.$route.params.id}/evaluate`
      );
      // console.log(response.data);
      this.evaluateQuote = response.data;
    },
    async fetchParameterTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/parameterTypes`);
      // console.log(response.data);
      this.parameterTypes = response.data;
    },
    async fetchScaleFeeTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/scaleFeeTypes`);
      // console.log(response.data);
      this.scaleFeeTypes = response.data;
    },
    async fetchScalePercentageTypes() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scalePercentageTypes`
      );
      // console.log(response.data);
      this.scalePercentageTypes = response.data;
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchEvaluateQuote();
      }
    }
  },
  created() {
    this.fetchParameterTypes();
    this.fetchScaleFeeTypes();
    this.fetchScalePercentageTypes();
  }
};
</script>

<style scoped>
.ruleFail {
  background: #ffcccc;
  margin-top: 5px;
}

.ruleSuccess {
  background: #ccffcc;
  margin-top: 5px;
}
</style>